import { Component, HostBinding } from '@angular/core';
import { NavigationService } from './common-app/services/navigation.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { AppNameService } from 'common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @HostBinding('attr.app-version') appVersionAttr = environment.appVersion;
  title = 'pickingonline';
  constructor(
    private appNameService: AppNameService,
    private navigationService: NavigationService,
    private auth: AuthService) {
    this.navigationService.startSaveHistory();
    this.appNameService.appName = 'pickingonline';

    this.auth.error$.subscribe(error => console.error('Error de Auth0:', error));
  }
}
